"use strict";

module.exports = {
  '56': {
      e: '8:00',
      r: {}
  }
};

